import { render, staticRenderFns } from "./purchase-order-direct-delivery.vue?vue&type=template&id=6101661a&scoped=true&"
import script from "./purchase-order-direct-delivery.vue?vue&type=script&lang=js&"
export * from "./purchase-order-direct-delivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6101661a",
  null
  
)

export default component.exports